import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { IDocExportRequest, HttpUtil, ApiResponse } from '@aa/common';

const PDF_URL = '/api/selfserv/export/pdf';

@Injectable({providedIn: 'root'})
export class PdfDownloadService {

  constructor(private readonly http: HttpClient) {}

  // called by app initializer in core module
  public download(req: IDocExportRequest): Observable<ApiResponse> {

    return this.http.request('POST', PDF_URL, {
      responseType: 'blob',
      observe: 'response',
      body: req
    }).pipe(
      map((res: HttpResponse<Blob>) => HttpUtil.parseBlobResponse(res)),
      catchError(HttpUtil.handleError)
    );
  }
}
